<template>
  <v-app class="patient-modal-app">
    <div>

      <b-modal
        ref="patientModal"
        v-model="isModalVisible"
        id="modal-patient"
        size="xl"
        :modal-class="patientModalClass"
        content-class="patient-picker-modal__content"
        header-class="patient-picker-modal__header"
        body-class="patient-picker-modal__body"
        hide-footer
        @shown="handleModalShown"
        @hide="handleModalHide"
        @hidden="handleModalHidden"
      >
        <template #modal-title>
          <div class="patient-modal-title">
            <span class="patient-modal-title__icon"><i class="fas fa-user-injured"></i></span>
            <span>
              <strong>Pilih pasien</strong>
              <small>Cari pasien terdaftar atau tambahkan data pasien baru.</small>
            </span>
          </div>
        </template>

        <!-- Tabs -->
        <b-tabs
          v-model="activeTab"
          class="patient-modal-tabs"
          nav-class="patient-modal-tabs__nav"
        >
          <b-tab title="Daftar Pasien">
            <div class="patient-modal-panel">
              <div class="patient-modal-panel__heading">
                <div>
                  <span class="patient-modal-eyebrow">Data pasien</span>
                  <h4>Pilih pasien terdaftar</h4>
                </div>
                <span class="patient-modal-panel__hint">
                  <i class="fas fa-search"></i>
                  Gunakan filter untuk mempercepat pencarian
                </span>
              </div>
              <Table
                purpose="modal"
                :selectedDoctor="selectedDoctor"
                @choosePatient="chosenPatient"
              />
            </div>
          </b-tab>
          <b-tab title="Tambah Baru">
            <div class="patient-modal-panel patient-modal-panel--form" v-if="!isCashier">
              <div class="patient-modal-panel__heading">
                <div>
                  <span class="patient-modal-eyebrow">Pasien baru</span>
                  <h4>Lengkapi informasi pasien</h4>
                </div>
                <span class="patient-modal-panel__hint">
                  <i class="fas fa-shield-alt"></i>
                  Data disimpan dengan aman
                </span>
              </div>
              <Form :form="form" :route="'patients'" purpose="modal" @submitPatient="submitedPatient" :source="source"/>
            </div>
            <div v-if="isCashier" class="patient-modal-panel patient-modal-panel--cashier">
              <div class="patient-modal-panel__heading">
                <div>
                  <span class="patient-modal-eyebrow">Pasien baru</span>
                  <h4>Tambahkan pasien dengan cepat</h4>
                </div>
              </div>
              <b-form @submit.stop.prevent="customPatientFormOnSubmit">
                <b-form-group id="input-group-name" label="Nama Pasien:" label-for="input-name">
                  <b-form-input id="input-name" v-model="form.name" placeholder="Nama Pasien" required></b-form-input>
                </b-form-group>
                <!-- Button -->
                <b-button type="submit" variant="primary">Simpan</b-button>
                <b-button class="ml-2" variant="default" @click="$bvModal.hide('modal-patient')">
                  Batal
                </b-button>
              </b-form>
            </div>
          </b-tab>
        </b-tabs>
      </b-modal>

    </div>
  </v-app>
</template>

<script>

import Form from '@/component/patients/Form.vue'
import Table from '@/component/patients/TablePatientPayment.vue'

export default {

  props: {
    selectedDoctor: String,
    isCashier: Boolean,
    source: {
      type: String,
      default: ''
    },
    patientPrefill: {
      type: Object,
      default: () => ({})
    }
  },

  components: {
    Form,
    Table
  },

  methods: {

    handleModalShown() {
      document.body.classList.add('patient-picker-open')
    },

    handleModalHide() {
      const activeElement = document.activeElement
      const modalOuter = document.getElementById('modal-patient___BV_modal_outer_')
      if (
        activeElement &&
        modalOuter &&
        modalOuter.contains(activeElement) &&
        typeof activeElement.blur === 'function'
      ) {
        activeElement.blur()
      }
    },

    handleModalHidden() {
      document.body.classList.remove('patient-picker-open')
      this.activeTab = 0

      if (this.pendingPatientSelection) {
        const patient = this.pendingPatientSelection
        this.pendingPatientSelection = null
        this.$emit('submitedPatient', patient)
      }

      if (this.pendingSuccessMessage) {
        this.pendingSuccessMessage = false
        this.$nextTick(() => {
          Swal.fire({
            title: 'Berhasil',
            text: 'Pasien berhasil ditambahkan dan langsung dipilih.',
            icon: 'success',
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true
          })
        })
      }
    },

    chosenPatient(value) {
      this.closePatientModal()
      this.$emit('chosenPatient', value)
    },

    submitedPatient(value) {
      this.pendingSuccessMessage = true
      this.pendingPatientSelection = value
      this.closePatientModal()
    },

    closePatientModal() {
      this.handleModalHide()
      this.isModalVisible = false

      const modal = this.$refs.patientModal
      if (modal && typeof modal.hide === 'function') {
        modal.hide('programmatic')
        return
      }

      this.$root.$emit('bv::hide::modal', 'modal-patient')
    },

    customPatientFormOnSubmit() {
      this.$emit('customSubmitedPatient', this.form.name)
    }

  },

  data() {
    return {
      activeTab: 0,
      isModalVisible: false,
      pendingSuccessMessage: false,
      pendingPatientSelection: null,
      form: {
        email: "",
        name: "",
        patient_id: "",
        birt_place: "",
        birt_date: "",
        address: "",
        gender: "",
        phone: "",
        mobile_phone: "",
        parent_name: "",
        blood_type: "",
        id_card_number: "",
        allergy: "",
        password: "",
        password_confirmation: "",
        status: "",
        title: "",
        doctor_in_charge: [],
        responsible_doctor: [],
        photo: [],
        photo_name: s3Endpoint + "/assets/public/default-profile.svg",
        photo_default: "/assets/public/default-profile.svg",
        notes: "",
        ss_patient_id: "",
        country_id: null,
        isResetImg: false,
        province_id: null,
        capital_id: null,
        subdistrict_id: null,
        village_id: null,
        modalForm: true,
      }
    }
  },

  computed: {
    patientModalClass() {
      return this.source === 'template-print'
        ? 'patient-picker-modal patient-picker-modal--template-print'
        : 'patient-picker-modal'
    }
  },

  watch: {
    patientPrefill: {
      deep: true,
      immediate: true,
      handler(value) {
        if (!value || Object.keys(value).length === 0) return
        Object.assign(this.form, value)
        this.activeTab = 1
      }
    }
  },

  beforeDestroy() {
    document.body.classList.remove('patient-picker-open')
  }

}
</script>

<style lang="scss">
.patient-modal-app.theme--light.v-application,
.patient-modal-app .v-application--wrap {
  min-height: 0 !important;
  background: transparent !important;
}

.patient-picker-modal {
  --patient-navy: var(--skin-deep);
  --patient-blue: var(--skin-primary);
  --patient-teal: var(--skin-secondary);
  --patient-border: #e3eaf2;
  --patient-muted: #6b7280;
  padding: 10px 0;
  z-index: 1210 !important;
}

body.patient-picker-open .modal-backdrop {
  z-index: 1200 !important;
}

.patient-picker-modal .modal-dialog {
  width: calc(100% - 32px);
  max-width: 1240px;
  margin: 0 auto;
}

.patient-picker-modal .patient-picker-modal__content {
  max-height: calc(100vh - 20px);
  overflow: hidden;
  border: 1px solid var(--patient-border) !important;
  border-radius: 20px !important;
  background: #fff !important;
  box-shadow: 0 28px 70px rgba(var(--skin-deep-rgb), 0.22) !important;
}

.patient-picker-modal .patient-picker-modal__header {
  min-height: 62px;
  padding: 10px 16px !important;
  border-bottom: 1px solid var(--patient-border) !important;
  background: linear-gradient(110deg, rgba(var(--skin-deep-rgb), 0.07), rgba(var(--skin-secondary-rgb), 0.06)) !important;
}

.patient-picker-modal .patient-picker-modal__header .close {
  display: grid;
  width: 36px;
  height: 36px;
  margin: 0 !important;
  padding: 0 !important;
  place-items: center;
  color: #607086;
  border: 1px solid var(--patient-border);
  border-radius: 10px;
  background: #fff;
  font-size: 20px;
  line-height: 1;
  opacity: 1;
  text-shadow: none;
}

.patient-picker-modal .patient-picker-modal__body {
  max-height: calc(100vh - 82px);
  padding: 12px 16px 14px !important;
  overflow-x: hidden;
  overflow-y: auto;
  background: #fff;
}

.patient-modal-title {
  display: flex;
  align-items: center;
  gap: 11px;
}

.patient-modal-title__icon {
  display: grid;
  width: 38px;
  height: 38px;
  flex: 0 0 38px;
  place-items: center;
  color: #fff;
  border-radius: 12px;
  background: linear-gradient(135deg, var(--patient-navy), var(--patient-blue), var(--patient-teal));
  box-shadow: 0 7px 16px rgba(var(--skin-primary-rgb), 0.18);
}

.patient-modal-title__icon i,
.patient-picker-modal .patient-modal-title__icon i {
  display: inline-block !important;
  color: #FFFFFF !important;
  font-size: 15px !important;
  line-height: 1 !important;
  opacity: 1 !important;
  -webkit-text-fill-color: #FFFFFF !important;
}

.patient-modal-title strong,
.patient-modal-title small {
  display: block;
}

.patient-modal-title strong {
  margin-bottom: 2px;
  color: #1a2433;
  font-size: 16px;
  font-weight: 700;
}

.patient-modal-title small {
  color: var(--patient-muted) !important;
  font-size: 11px;
  font-weight: 500;
}

.patient-picker-modal .patient-modal-tabs > div:first-child {
  margin-bottom: 8px;
}

.patient-picker-modal .patient-modal-tabs__nav {
  display: inline-flex;
  width: auto;
  gap: 5px;
  padding: 4px;
  border: 1px solid var(--patient-border) !important;
  border-radius: 12px;
  background: #f7f9fc;
}

.patient-picker-modal .patient-modal-tabs__nav .nav-item {
  margin: 0;
}

.patient-picker-modal .patient-modal-tabs__nav .nav-link {
  min-height: 34px;
  margin: 0;
  padding: 7px 14px !important;
  color: var(--patient-muted) !important;
  border: 0 !important;
  border-radius: 9px !important;
  background: transparent !important;
  font-size: 12px;
  font-weight: 700;
}

.patient-picker-modal .patient-modal-tabs__nav .nav-link.active {
  color: #fff !important;
  background: linear-gradient(135deg, var(--patient-navy), var(--patient-blue), var(--patient-teal)) !important;
  box-shadow: 0 5px 12px rgba(var(--skin-primary-rgb), 0.17);
}

.patient-modal-panel {
  margin-top: 0;
}

.patient-modal-panel__heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 8px;
  padding-bottom: 8px;
  border-bottom: 1px solid #edf1f5;
}

.patient-modal-eyebrow {
  display: block;
  margin-bottom: 3px;
  color: var(--patient-teal);
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.11em;
  text-transform: uppercase;
}

.patient-modal-panel__heading h4 {
  margin: 0;
  color: #1a2433 !important;
  font-size: 15px !important;
  font-weight: 700;
}

.patient-modal-panel__hint {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  min-height: 30px;
  padding: 6px 9px;
  color: #607086;
  border: 1px solid var(--patient-border);
  border-radius: 9px;
  background: #f8fafc;
  font-size: 10px;
  font-weight: 600;
}

.patient-modal-panel__hint i {
  color: var(--patient-teal);
}

/* Patient list filters */
.patient-picker-modal .patient-modal-panel .v-application,
.patient-picker-modal .patient-modal-panel .v-application--wrap {
  min-height: 0 !important;
  background: transparent !important;
}

.patient-picker-modal .patient-modal-panel .row {
  margin-left: -6px;
  margin-right: -6px;
}

.patient-picker-modal .patient-modal-panel [class*="col-"] {
  padding-left: 6px;
  padding-right: 6px;
}

.patient-picker-modal .patient-modal-panel .mt-n3,
.patient-picker-modal .patient-modal-panel .mt-n4 {
  margin-top: 0 !important;
}

.patient-picker-modal .btn-timeseries {
  min-height: 30px !important;
  margin: 1px 2px !important;
  padding: 5px 9px !important;
  border-radius: 9px !important;
  font-size: 10px !important;
}

.patient-picker-modal .form-control,
.patient-picker-modal .custom-select,
.patient-picker-modal .vue-treeselect__control {
  height: 36px !important;
  min-height: 36px !important;
  padding: 6px 10px !important;
  color: #1a2433 !important;
  border: 1px solid #dbe4ee !important;
  border-radius: 10px !important;
  background: #fff !important;
  box-shadow: none !important;
  font-size: 12px !important;
}

.patient-picker-modal textarea.form-control {
  height: auto !important;
  min-height: 78px !important;
}

.patient-picker-modal .input-group-text {
  min-height: 36px;
  padding: 7px 10px;
  color: #718096 !important;
  border-color: #dbe4ee !important;
  border-radius: 10px 0 0 10px !important;
  background: #f8fafc !important;
}

.patient-picker-modal .input-group > .form-control:not(:first-child) {
  border-radius: 0 10px 10px 0 !important;
}

.patient-picker-modal .input-group-append .btn,
.patient-picker-modal .input-group-prepend .btn {
  min-height: 40px;
  padding: 7px 11px !important;
  border-radius: 0 !important;
  font-size: 11px !important;
}

.patient-picker-modal .input-group-append .btn:last-child {
  border-radius: 0 10px 10px 0 !important;
}

.patient-picker-modal .form-group {
  margin-bottom: 12px;
}

.patient-picker-modal .form-group label,
.patient-picker-modal .col-form-label {
  margin-bottom: 5px;
  color: #40536b !important;
  font-size: 11px !important;
  font-weight: 700 !important;
}

.patient-picker-modal small.text-muted {
  display: block;
  margin-top: 4px;
  color: #8a96a8 !important;
  font-size: 9px;
}

/* Dense patient table */
.patient-picker-modal .table-responsive,
.patient-picker-modal .table-responsive-sm {
  margin-top: 8px !important;
  overflow-x: auto;
  border: 1px solid var(--patient-border);
  border-radius: 12px;
}

.patient-picker-modal .table {
  margin-bottom: 0;
}

.patient-picker-modal .table thead th {
  height: 31px;
  padding: 6px 10px !important;
  color: #52667d !important;
  background: #f7f9fc !important;
  border-bottom: 1px solid var(--patient-border) !important;
  font-size: 9px !important;
  font-weight: 800 !important;
  letter-spacing: 0.055em;
  text-transform: uppercase;
  white-space: nowrap;
}

.patient-picker-modal .table tbody td {
  height: 45px;
  padding: 5px 10px !important;
  color: #334155 !important;
  border-bottom: 1px solid #edf1f5 !important;
  font-size: 11px;
  vertical-align: middle;
}

.patient-picker-modal .table tbody tr:hover td {
  background: #f6fbfa !important;
}

.patient-picker-modal .pagination {
  gap: 4px;
  margin-top: 8px !important;
  margin-bottom: 0;
}

.patient-picker-modal .page-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 34px;
  height: 34px;
  padding: 0 9px !important;
  color: #40536B !important;
  border-color: #DCE5EE !important;
  border-radius: 8px !important;
  background: #FFFFFF !important;
  font-size: 13px !important;
  font-weight: 800 !important;
  line-height: 1 !important;
  opacity: 1 !important;
}

.patient-picker-modal .page-item.active .page-link {
  color: #FFFFFF !important;
  border-color: var(--skin-primary) !important;
  background: linear-gradient(135deg, var(--skin-deep), var(--skin-primary), var(--skin-secondary)) !important;
  box-shadow: 0 5px 12px rgba(var(--skin-primary-rgb), 0.22) !important;
}

.patient-picker-modal .page-item.disabled .page-link {
  color: #94A3B8 !important;
  background: #F6F8FA !important;
  opacity: 1 !important;
}

.patient-picker-modal .page-item:not(.disabled):not(.active) .page-link:hover {
  color: var(--skin-primary) !important;
  border-color: #AFC5D7 !important;
  background: #EDF6F8 !important;
}

.patient-picker-modal .table tbody td ul {
  margin: 0 !important;
  padding: 0 !important;
}

.patient-picker-modal .patient-picker-photo,
.patient-picker-modal .patient-picker-photo__frame {
  width: 32px;
  height: 32px;
}

.patient-picker-modal .patient-picker-photo__frame {
  overflow: hidden;
  border: 1px solid #DDE6EF;
  border-radius: 50%;
  background: #F1F6F8;
}

.patient-picker-modal .patient-picker-photo__image {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.patient-picker-modal .table tbody .btn {
  min-height: 32px !important;
  padding: 5px 12px !important;
}

/* Add patient form */
.patient-picker-modal .patient-modal-panel--form .image-container {
  min-height: 0 !important;
  padding: 10px;
  border: 1px dashed #cfdbe7;
  border-radius: 14px;
  background: #f8fafc;
}

.patient-picker-modal .patient-modal-panel--form .image-container > div {
  width: 190px !important;
  height: 190px !important;
  max-width: 100%;
}

.patient-picker-modal .patient-modal-panel--form .image-container img {
  border-radius: 12px;
  object-fit: cover;
}

.patient-picker-modal .patient-modal-panel--form .font-weight-bold,
.patient-picker-modal .patient-modal-panel--form .col-md-12 > span.font-weight-bold {
  color: var(--patient-navy) !important;
  font-size: 12px;
}

.patient-picker-modal .patient-modal-panel--form .btn-outline-danger.btn-circle {
  display: inline-grid !important;
  width: 34px !important;
  min-width: 34px !important;
  height: 34px !important;
  min-height: 34px !important;
  padding: 0 !important;
  place-items: center;
  color: #d14343 !important;
  border: 1px solid rgba(239, 68, 68, 0.24) !important;
  border-radius: 10px !important;
  background: rgba(239, 68, 68, 0.07) !important;
  box-shadow: none !important;
}

.patient-picker-modal .patient-modal-panel--form .btn-outline-danger.btn-circle i {
  margin: 0 !important;
  padding: 0 !important;
  color: inherit !important;
  font-size: 12px;
  line-height: 1;
}

.patient-picker-modal .patient-modal-panel--form .btn-outline-danger.btn-circle:hover {
  color: #fff !important;
  border-color: #ef4444 !important;
  background: #ef4444 !important;
  box-shadow: 0 6px 14px rgba(239, 68, 68, 0.2) !important;
  transform: translateY(-1px);
}

.patient-picker-modal .custom-control {
  margin: 3px 8px 3px 0 !important;
}

.patient-picker-modal .custom-control-label {
  color: #526174;
  font-size: 11px;
}

.patient-picker-modal .vue-treeselect__control {
  padding: 0 4px !important;
}

.patient-picker-modal .vue-treeselect__value-container,
.patient-picker-modal .vue-treeselect__input-container,
.patient-picker-modal input.vue-treeselect__input {
  height: 38px !important;
  min-height: 0 !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  border: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
  line-height: 38px !important;
}

.patient-picker-modal .vue-treeselect__placeholder,
.patient-picker-modal .vue-treeselect__single-value {
  color: #6b7280 !important;
  font-size: 11px !important;
  line-height: 38px !important;
}

.patient-picker-modal .btn:not(.btn-icon) {
  min-height: 36px;
  padding: 7px 13px !important;
  border-radius: 9px !important;
  font-size: 11px !important;
  font-weight: 700;
}

.patient-picker-modal .btn-primary,
.patient-picker-modal .btn-success,
.patient-picker-modal .btn-info {
  color: #fff !important;
  border-color: transparent !important;
  background: linear-gradient(135deg, var(--patient-navy), var(--patient-blue), var(--patient-teal)) !important;
  box-shadow: 0 5px 12px rgba(var(--skin-primary-rgb), 0.15) !important;
}

.patient-modal-panel--cashier {
  max-width: 560px;
}

@media (max-width: 767.98px) {
  .patient-picker-modal {
    padding: 8px 0;
  }

  .patient-picker-modal .modal-dialog {
    width: calc(100% - 16px);
  }

  .patient-picker-modal .patient-picker-modal__content {
    max-height: calc(100vh - 16px);
    border-radius: 16px !important;
  }

  .patient-picker-modal .patient-picker-modal__header {
    min-height: 64px;
    padding: 11px 13px !important;
  }

  .patient-picker-modal .patient-picker-modal__body {
    max-height: calc(100vh - 81px);
    padding: 13px !important;
  }

  .patient-modal-title small,
  .patient-modal-panel__hint {
    display: none;
  }

  .patient-modal-panel__heading {
    margin-bottom: 11px;
  }

  .patient-picker-modal .patient-modal-tabs__nav {
    display: flex;
    width: 100%;
  }

  .patient-picker-modal .patient-modal-tabs__nav .nav-item {
    flex: 1 1 50%;
  }

  .patient-picker-modal .patient-modal-tabs__nav .nav-link {
    text-align: center;
  }
}
</style>
